import Anchor from '../../foundation/Anchor';

function RegistrationTermsText() {
    return <>
        בהרשמה ל־Mploy הנך מאשר/ת שקראת והנך מסכימ/ה ל
        <Anchor href="/home/regulations" text="תנאי השימוש" blank />,
        {' '}לקבלת דואר פרסומי הכולל הצעות משרות במייל ובנייד, ול
        <Anchor href="/home/privacy" text="מדיניות הפרטיות" blank />.
    </>;
}

export default RegistrationTermsText;
